import { useRef, useState, useCallback } from "react";

// Reusable reCAPTCHA v2 state for any form.
// Usage:
//   const { captchaRef, captchaToken, onCaptchaChange, onCaptchaExpired, resetCaptcha } = useRecaptcha();
//   <ReCAPTCHA ref={captchaRef} sitekey={RECAPTCHA_SITE_KEY}
//              onChange={onCaptchaChange} onExpired={onCaptchaExpired} />
//   <button disabled={!captchaToken}>Submit</button>

export const RECAPTCHA_SITE_KEY = "6Lc6LUscAAAAAKO2DYPGrIPSnwx3fzROCxJzNWQ0"; //process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const useRecaptcha = () => {
  const captchaRef = useRef(null);
  const [captchaToken, setCaptchaToken] = useState("");

  // Called by Google when the user ticks the box (value = token)
  const onCaptchaChange = useCallback((value) => {
    setCaptchaToken(value || "");
  }, []);

  // Token expires after ~2 minutes; force the user to tick again
  const onCaptchaExpired = useCallback(() => {
    setCaptchaToken("");
  }, []);

  // A token can only be verified once, so reset after every submit attempt
  const resetCaptcha = useCallback(() => {
    captchaRef.current?.reset();
    setCaptchaToken("");
  }, []);

  return {
    captchaRef,
    captchaToken,
    onCaptchaChange,
    onCaptchaExpired,
    resetCaptcha,
  };
};

export default useRecaptcha;
